module.exports = __webpack_public_path__ + "static/media/icon_data-stewards.ebd6110f.svg";